import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_carousel_navigation = _resolveComponent("base-carousel-navigation")
  const _component_base_carousel_indicators = _resolveComponent("base-carousel-indicators")
  const _component_base_carousel = _resolveComponent("base-carousel")
  const _component_zoomable_gallery = _resolveComponent("zoomable-gallery")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-product-details-gallery', {'_mb-6': $props.images.length > 1}])
  }, [
    _createVNode(_component_base_carousel, {
      class: "gfu-product-details-slider",
      autoplay: true,
      onChange: $options.onChange
    }, {
      default: _withCtx(({ currentItem }) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.images, (image, index) => {
          return (_openBlock(), _createElementBlock("a", {
            key: image.productImage + index,
            href: image.productZoomImage,
            class: _normalizeClass(['gfu-product-details-slider__slide', {'is-active': currentItem === index}]),
            onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onZoom && $options.onZoom(...args)), ["prevent"]))
          }, [
            ($options.shouldLoad(index))
              ? (_openBlock(), _createBlock(_component_base_image, {
                  key: 0,
                  alt: `gallery-image-${index + 1}`,
                  src: image.productImage,
                  loading: "lazy",
                  class: "gfu-product-details-slider__image"
                }, null, 8 /* PROPS */, ["alt", "src"]))
              : _createCommentVNode("v-if", true)
          ], 10 /* CLASS, PROPS */, _hoisted_1))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      nav: _withCtx(({ onNext, onPrev }) => [
        _createVNode(_component_base_carousel_navigation, {
          type: "prev",
          icon: "angle-left",
          "has-icon-base-class": false,
          onClick: onPrev
        }, null, 8 /* PROPS */, ["onClick"]),
        _createVNode(_component_base_carousel_navigation, {
          type: "next",
          icon: "angle-right",
          "has-icon-base-class": false,
          onClick: onNext
        }, null, 8 /* PROPS */, ["onClick"])
      ]),
      indicators: _withCtx(({ currentItem, onSetCurrentIndex }) => [
        _createVNode(_component_base_carousel_indicators, {
          class: "gfu-product-details-slider__indicators",
          "current-item": currentItem,
          "items-count": $props.images.length,
          onSelected: onSetCurrentIndex
        }, null, 8 /* PROPS */, ["current-item", "items-count", "onSelected"])
      ]),
      actions: _withCtx(() => [
        ($props.hasZoom)
          ? (_openBlock(), _createBlock(_component_base_carousel_navigation, {
              key: 0,
              type: "zoom",
              icon: "search-plus",
              onClick: $options.onZoom
            }, null, 8 /* PROPS */, ["onClick"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onChange"]),
    (_ctx.modalIsVisible)
      ? (_openBlock(), _createBlock(_component_zoomable_gallery, {
          key: 0,
          "current-media": _ctx.currentImage,
          media: $options.zoomableImages,
          onClose: $options.onClose
        }, null, 8 /* PROPS */, ["current-media", "media", "onClose"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}